module.exports = __webpack_public_path__ + "img/amex.cff8ff25.svg";